import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=c235f190&scoped=true&"
import script from "./adminLayout.vue?vue&type=script&lang=js&"
export * from "./adminLayout.vue?vue&type=script&lang=js&"
import style0 from "./adminLayout.vue?vue&type=style&index=0&id=c235f190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c235f190",
  null
  
)

export default component.exports